/**
 * Scripts spécifiques aux pages des lignes de produit dans la section aftermarket.
 */
import "./main";
// Pages lignes de produit
import { RechercheParVehicule } from "./modules/recherche_par_vehicule";
// Instancier le module de recherche par véhicule
new RechercheParVehicule('recherche-par-vehicule');
